import moment from "moment";

// A student's dob reaches the register flow in more than one shape: the
// "MM/DD/YYYY" string typed into the step-1 mask, or the server's serialized
// value once a step 2/3 response — or a resumed application — writes it into
// the store. Parse against every shape rather than assuming one.
export const DOB_FORMATS = [
  "MM/DD/YYYY",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD",
  moment.ISO_8601,
];

export const parseDob = (value: any) => moment(value, DOB_FORMATS);

// The step-1 input is masked "99/99/9999", so it needs "MM/DD/YYYY" or an empty
// string — anything else gets shuffled into the mask ("1980-01-01 00:00:00"
// renders as "19/80/0101").
export const formatDobForInput = (value: any): string => {
  const parsed = parseDob(value);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "";
};
